import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFinishedGoodsReceiptContentForm,
    type StockFinishedGoodsReceiptContentFormProps,
} from "./components/StockFinishedGoodsReceiptContentForm/StockFinishedGoodsReceiptContentForm";

/** Реестр overlay-окон карточки приемки СГП. */
export const stockFinishedGoodsReceiptCardWindows = {
    content: defineMobileFormWindow<StockFinishedGoodsReceiptContentFormProps>({
        key: "stock.finishedGoodsReceipt.content",
        title: "Размещение продукции",
        component: StockFinishedGoodsReceiptContentForm,
    }),
};
